// extracted by mini-css-extract-plugin
export default {"verify__resend":"VerifyResendCode_verify__resend__1QwVl"};